import React from 'react';

import { useAuth } from '../context/AuthContext';

export const Header: React.FC = () => {
  const { user, signOut } = useAuth();

  return (
    <header
      className="bg-[#001973] w-full min-w-[320px] px-[16px] py-[16px] flex items-center gap-[16px]"
      aria-label="ヘッダー"
    >
      <div className="flex items-center gap-[8px]">
        <img
          src="/figma_asset/HeaderIcon.svg"
          alt="SASオンラインロゴ"
          className="w-[40px] h-[27px]"
          loading="lazy"
        />
        <p className="text-[18px] text-[#f5f5f5] select-none">SAS オンライン</p>
      </div>
      <div className="ml-auto flex items-center gap-3">
        {user && (
          <>
            <div className="bg-white flex items-center justify-center rounded-full w-10 h-10 shadow-sm">
              <img
                src="/figma_asset/UserGray.svg"
                alt="ユーザーアイコン"
                className="w-6 h-6"
                loading="lazy"
              />
            </div>
            <p className="font-sans text-[14px] text-white leading-none">{user.username}</p>
            <button
              onClick={signOut}
              className="px-[15px] py-[10px] bg-[#c8c8c8] text-black rounded-[30px] text-[12px] hover:bg-[#bdbdbd]"
            >
              ログアウト
            </button>
          </>
        )}
      </div>
    </header>
  );
};
